import {router} from '@/router/router';
import {loginRoute} from '@/modules/Login/services/returnAddress';
export default {
	namespaced: true,
	state: {
		loginURL: '/auth/login',
		logoutURL: '/auth/logout',
		sessionURL: '/auth/session',
		resetPasswordURL: '/auth/password_reset/tokens',
		authentication: false,
	},
	getters: {
		isAuthenticated(state){
			return state.authentication;
		},
		getLoginURL(state){
			return state.loginURL;
		},
		getLogoutURL(state){
			return state.logoutURL;
		},
		getSessionURL(state){
			return state.sessionURL;
		},
		getResetPasswordURL(state){
			return state.resetPasswordURL;
		}
	},
	mutations: {
		AUTH_SET(state, status){
			state.authentication = status;
		},
	},
	actions: {
		setAuthentication({commit}, status){
			commit("AUTH_SET", status);
		},
		// `returnHere` is for signing in again mid-task: the login form then
		// leads back to the current page instead of the start page.
		logoutRequest({commit, dispatch}, {returnHere = false} = {}){
			const current = router.currentRoute.value;
			if (current.name !== 'login'){
				commit("AUTH_SET", false);
				dispatch("user/removeUser", null, {root: true});
				router.push(loginRoute(returnHere ? current.fullPath : undefined));
			}
		},
	}
}
